<section class="rea-section rea-main-status" [class.rea-main-status--error]="hasCurrentError">
	<div class="rea-main-status__icon">
		<i [class]="statusIcon" aria-hidden="true"></i>
	</div>

	<div class="rea-main-status__content">
		<h4>{{ viewState.title }}</h4>
		@if (showDescription) {
			<p>{{ viewState.description }}</p>
		}

		@if (hasCurrentError) {
			@if (viewState.nextStep) {
				<p class="rea-main-status__next-step">{{ viewState.nextStep }}</p>
			}

			@if (recoveryAction; as action) {
				@if (action.type === 'REA_AUTHORIZATION_GUIDE') {
					<div class="rea-authorization-help">
						<div class="rea-authorization-help__content">
							<p>El titular debe autorizar a la aplicación antes de importar el REA.</p>

							<a
								pButton
								class="p-button-sm p-button-warning rea-action-link"
								icon="pi pi-external-link"
								[href]="action.url"
								[target]="action.target ?? '_blank'"
								rel="noopener noreferrer"
							>
								{{ action.label }}
							</a>
						</div>
					</div>
				}
			}

			@if (hasSupportEmail) {
				<a
					pButton
					class="p-button-sm p-button-help rea-action-link"
					icon="pi pi-envelope"
					[href]="supportEmailHref"
					target="_blank"
					rel="noopener noreferrer"
				>
					Enviar error a soporte
				</a>
			}

			<app-rea-import-technical-details
				[details]="technicalDetails"
			></app-rea-import-technical-details>
		} @else if (primaryValueMessage) {
			<p class="rea-main-status__next-step">{{ primaryValueMessage }}</p>
		}
	</div>
</section>